import faker from 'faker'
import _ from 'lodash'
import moment from 'moment'

let mockCodshiftDropdown = []
const totalDropdown = 5 + Math.floor(Math.random() * 6)
for (var i = 1; i < totalDropdown; i++) {
  mockCodshiftDropdown.push({
    code: _.padStart(Math.floor(Math.random() * 1000), 4, '0'),
    desc_code: faker.lorem.word()
  })
}
let mockStaapprDropdown = [{
  code: 'P',
  desc_code: 'Pending'
}, {
  code: 'A',
  desc_code: 'Approving'
}, {
  code: 'C',
  desc_code: 'Cancel'
}, {
  code: 'Y',
  desc_code: 'Approved'
}, {
  code: 'N',
  desc_code: 'Rejected'
}]
let mockDropdowns = {
  codshift: mockCodshiftDropdown,
  staappr: mockStaapprDropdown
}
let mockMaxRowspan = 3
let mockColumns = [{
  key: 'codempid',
  name: 'Employee Code',
  style: 'min-width: 120px;',
  inlineType: 'text',
  validType: 'required|alpha'
}, {
  key: 'dte',
  name: 'Date',
  class: 'align-center',
  style: 'min-width: 360px;',
  headerRow: 1,
  colspan: 3,
  rowspan: 1
}, {
  key: 'dtereq',
  name: 'Date Request',
  class: 'align-center',
  style: 'min-width: 120px;',
  headerRow: 2,
  colspan: 1,
  rowspan: 2
}, {
  key: 'dtework',
  name: 'Date Work',
  class: 'align-center',
  style: 'min-width: 280px;',
  headerRow: 2,
  colspan: 2,
  rowspan: 1
}, {
  key: 'dtestrt',
  name: 'Start',
  class: 'align-center',
  style: 'min-width: 140px;',
  inlineType: 'date',
  headerRow: 3,
  colspan: 1,
  rowspan: 1
}, {
  key: 'dteend',
  name: 'End',
  class: 'align-center',
  style: 'min-width: 140px;',
  inlineType: 'date',
  headerRow: 3,
  colspan: 1,
  rowspan: 1
}, {
  key: 'codshift',
  name: 'Shift Code',
  class: 'align-center',
  style: 'min-width: 50px;',
  inlineType: 'select',
  inlineDropdown: mockDropdowns.codshift
}, {
  key: 'time',
  name: 'Time',
  class: 'align-center',
  style: 'min-width: 280px;',
  headerRow: 1,
  colspan: 2,
  rowspan: 2
}, {
  key: 'timin',
  name: 'Time in',
  class: 'align-center',
  style: 'min-width: 140px;',
  inlineType: 'time',
  headerRow: 3,
  colspan: 1,
  rowspan: 1
}, {
  key: 'timout',
  name: 'Time out',
  class: 'align-center',
  style: 'min-width: 140px;',
  inlineType: 'time',
  headerRow: 3,
  colspan: 1,
  rowspan: 1
}, {
//   key: 'staappr',
//   name: 'Status Approve',
//   style: 'min-width: 50px;',
//   inlineType: 'select',
//   inlineDropdown: mockDropdowns.staappr
// }, {
  key: 'remarkap',
  name: 'Remark Approve',
  style: 'min-width: 200px;',
  inlineType: 'textarea',
  validType: 'required|alpha'
}, {
  key: 'descCodappr',
  name: 'Approver',
  style: 'min-width: 100px;',
  eventName: 'codappr'
}, {
  key: 'descCodempap',
  name: 'Next Approver',
  style: 'min-width: 100px;',
  eventName: 'codempap'
}]
// let mockStaappr = [ 'P', 'A', 'C', 'Y', 'N' ]
let mockRows = []
const mockTotal = 100
for (var j = 1; j <= mockTotal; j++) {
  mockRows.push({
    id: j,
    codempid: faker.lorem.word(),
    dtestrt: moment().daysInMonth() + '/' + _.padStart(moment().month() + 1, 2, '0') + '/' + moment().year(),
    dteend: moment().daysInMonth() + '/' + _.padStart(moment().month() + 1, 2, '0') + '/' + moment().year(),
    dtereq: moment().daysInMonth() + '/' + _.padStart(moment().month() + 1, 2, '0') + '/' + moment().year(),
    codshift: _.padStart(Math.floor(Math.random() * 1000), 4, '0'),
    timin: faker.date.past().toString().substr(16, 5),
    timout: faker.date.past().toString().substr(16, 5),
    // staappr: mockStaappr[Math.floor(Math.random() * 5)],
    staappr: '',
    remarkap: faker.lorem.sentence(),
    descCodappr: faker.lorem.word(),
    descCodempap: faker.lorem.word()
  })
}

export { mockColumns, mockMaxRowspan, mockTotal, mockRows }



// WEBPACK FOOTER //
// ./src/components/test1/mockData.js